"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClosingConfirmationDialog = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const Warning_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Warning/Warning.svg"));
const FeatureContext_1 = require("../../../../core/contexts/FeatureContext");
require("./types");
exports.ClosingConfirmationDialog = react_1.default.memo(({ message, texts, isExitWizard, onRequestClose, onDone, onCancel, secondaryActions, width, iconSrc = Warning_svg_1.default, }) => {
    const { t } = FeatureContext_1.useFeatureContext();
    return (react_1.default.createElement(components_1.Dialog, { id: "closingConfirmationDialog", header: (texts === null || texts === void 0 ? void 0 : texts.header) || t('closingConfirmationDialog|header'), size: {
            width: width || components_1.DIALOG_SIZE.auto,
            height: components_1.DIALOG_SIZE.auto,
        }, onRequestClose: () => {
            onRequestClose();
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        }, actions: [
            {
                id: 'done',
                view: components_1.ACTION_VIEW.primary,
                text: (texts === null || texts === void 0 ? void 0 : texts.done) || t('closingConfirmationDialog|actions|done'),
                onClick: () => {
                    onRequestClose();
                    onDone === null || onDone === void 0 ? void 0 : onDone();
                },
            },
            {
                id: 'cancel',
                view: components_1.ACTION_VIEW.secondary,
                text: (texts === null || texts === void 0 ? void 0 : texts.cancel) || t('closingConfirmationDialog|actions|cancel'),
                onClick: () => {
                    onRequestClose();
                    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                },
            },
        ], secondaryActions: secondaryActions },
        react_1.default.createElement(components_1.StackView, { gap: components_1.STACK_GAP.m, align: components_1.STACK_ALIGN.center },
            react_1.default.createElement(components_1.Icon, { src: iconSrc, size: components_1.ICON_SIZES.xl }),
            react_1.default.createElement(components_1.Text, null, message || isExitWizard
                ? (texts === null || texts === void 0 ? void 0 : texts.exitWizard) || t('closingConfirmationDialog|message|exitWizard')
                : (texts === null || texts === void 0 ? void 0 : texts.exit) || t('closingConfirmationDialog|message|exit')))));
});
exports.ClosingConfirmationDialog.displayName = 'ClosingConfirmationDialog';
//# sourceMappingURL=ClosingConfirmationDialog.js.map